module["exports"] = [
  "0#-#######",
  "02-########",
  "09##-######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/phone_number/formats.js
// module id = 2879
// module chunks = 2